import { render, staticRenderFns } from "./MobileBottomNavigation.vue?vue&type=template&id=0c7c385a&scoped=true&lang=pug&"
import script from "./MobileBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./MobileBottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MobileBottomNavigation.vue?vue&type=style&index=0&id=0c7c385a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c385a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VIcon})
